import { useState } from "react";
import { useSelector } from "react-redux";
import PaymentLayout from "../layouts/PaymentLinkLayouts";
import CountDownTimer from "./CountDownTimer";
import formatCurrency from "../../utils/numberFormatter";
import { ChevronDown, ChevronUp, CreditCard, Wallet } from "lucide-react"; // Ikon untuk toggle
import METHOD_LOGO from "./MethodLogos";
import { useNavigate } from "react-router-dom";

// Placeholder untuk logo bank (sesuaikan dengan yang kamu punya)
const METHOD_LOGOS = METHOD_LOGO;

export default function PaymentMethod({
  amount,
  orderId,
  paymentTo,
  customerData,
  onSelectMethod,
  paymentMethodOptions,
  expiredAt // PaymentLink expired_at for countdown
}) {
  const [isCustomerDetailOpen, setIsCustomerDetailOpen] = useState(false); // State untuk toggle tab
  const navigate = useNavigate();
  const { card_title } = useSelector((state) => state.style);
  const [integerPart, decimalPart] = formatCurrency(amount).split(",");

  return (
    <PaymentLayout title={card_title || paymentTo}>
      {/* Payment Amount */}
      <div>
        <h2 className="text-4xl font-bold">
          <span>{integerPart}</span>
          {/* <span className="text-base">,{decimalPart}</span> */}
        </h2>
        <p className="text-gray-600 mt-2">ID {orderId}</p>
        <p className="text-gray-600">To {paymentTo}</p>
      </div>

      {/* Timer */}
      <div className="bg-gray-50 p-4 rounded-lg text-center">
        <p className="text-gray-600">
          Choose within <CountDownTimer expiredAt={expiredAt} onExpire={() => navigate(-1)} />
        </p>
      </div>

      {/* Customer Details (Jika Ada) */}
      {customerData?.fullName && customerData?.phone && customerData?.email && (
        <div className="border-t border-gray-200 pt-4">
          {/* Toggle Button */}
          <button
            onClick={() => setIsCustomerDetailOpen(!isCustomerDetailOpen)}
            className="w-full flex justify-between items-center p-3 text-lg font-semibold bg-gray-100 rounded-md hover:bg-gray-200 transition-colors"
          >
            Customer Details
            {isCustomerDetailOpen ? <ChevronUp size={20} /> : <ChevronDown size={20} />}
          </button>

          {/* Detail Customer (Tampilkan jika isCustomerDetailOpen = true) */}
          {isCustomerDetailOpen && (
            <div className="p-4 bg-white border border-gray-300 rounded-md mt-2 transition-all">
              <div className="space-y-2">
                <div>
                  <span className="text-sm text-gray-500">Full Name</span>
                  <div className="text-base font-medium">{customerData.fullName}</div>
                </div>
                <div>
                  <span className="text-sm text-gray-500">Phone</span>
                  <div className="text-base font-medium">{customerData.phone}</div>
                </div>
                <div>
                  <span className="text-sm text-gray-500">Email</span>
                  <div className="text-base font-medium">{customerData.email}</div>
                </div>
              </div>
            </div>
          )}
        </div>
      )}

      {/* Payment Methods */}
      <div className="border-t border-gray-200 pt-4">
        <h3 className="text-xl font-semibold mb-4">All payment methods</h3>
        <div className="space-y-3">
          {paymentMethodOptions.map((method) => (
            <button
              key={method.code}
              onClick={() => onSelectMethod(method.code)}
              className="w-full p-4 flex items-center gap-4 bg-white border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors "
            >
              {METHOD_LOGOS[method.code] ? (
                <img
                  src={METHOD_LOGOS[method.code]}
                  alt={`${method.name} logo`}
                  className="w-10 h-10 object-contain"
                />
              ) : method.group === "card" ? (
                <CreditCard className="w-10 h-10 shrink-0 text-gray-700" aria-hidden />
              ) : (
                <div className="w-10 h-10 shrink-0 rounded bg-gray-200 flex items-center justify-center" aria-hidden>
                  <Wallet className="w-5 h-5 text-gray-500" />
                </div>
              )}
              <span className="font-medium">{method.name}</span>
              <span className="font-medium ml-auto text-xs text-gray-600">{method.desc}</span>
            </button>
          ))}
        </div>
      </div>
    </PaymentLayout>
  );
}
